export const styleOptions = options => {
    let styles = '';

    if (options.largeMobileControls) {
        styles += `
.video-js .vjs-control-bar {
    height: 25%;
    font-size: 2.7em;
}

.video-js .vjs-control-bar button {
    width: 2.5em;
}

.video-js .vjs-volume-control.vjs-control {
    display: none;
}

.video-js .vjs-volume-panel.vjs-volume-panel-horizontal,
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal,
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal,
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:hover,
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active,
.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {
    width: auto;
}
        `;
    }

    return styles;
};